module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMi43MDYiIGhlaWdodD0iMjMuNzIzIiB2aWV3Qm94PSIwIDAgMTIuNzA2IDIzLjcyMyI+DQogIDxwYXRoIGlkPSJJY29uX2F3ZXNvbWUtZmFjZWJvb2stZiIgZGF0YS1uYW1lPSJJY29uIGF3ZXNvbWUtZmFjZWJvb2stZiIgZD0iTTEzLjQ4MywxMy4zNDRsLjY1OS00LjI5M2gtNC4xMlY2LjI2NWEyLjE0NywyLjE0NywwLDAsMSwyLjQyLTIuMzE5aDEuODczVi4yOUEyMi44MzksMjIuODM5LDAsMCwwLDEwLjk5MSwwQzcuNiwwLDUuMzgxLDIuMDU2LDUuMzgxLDUuNzc5VjkuMDUxSDEuNjA5djQuMjkzSDUuMzgxVjIzLjcyM2g0LjY0MVYxMy4zNDRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMS42MDkpIiBmaWxsPSIjZmZmIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icn_facebook.svg
// module id = djBh
// module chunks = 0